import React from 'react'
import RelatedArticlesGrid from 'components/shared/RelatedArticlesGrid'

import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'

const RelatedArticles = (props) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps
  
return <RelatedArticlesGrid customCardProps={customCardProps} {...props} />
}

export default RelatedArticles
